import './style.less';

export default courses => {
  return ($scope, $q, $state, $stateParams, $uibModalInstance) => {
    'ngInject';
    $scope.courses = courses;
    $scope.createCourse = () => {
      $scope.close();
      $state.go('app.author.courses', $stateParams);
    };

    $scope.close = () => $uibModalInstance.dismiss('cancel');

    $scope.add = course => {
      $scope.close();
      $state.go('app.eventManager.course.event.event-info', { courseid: course.course_id, eventid: '' });
    };
  };
};



// WEBPACK FOOTER //
// ./src/app/modals/addCourse/index.js